/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type {
	ConcreteRequest,
	Variables,
	OperationType,
	PreloadableConcreteRequest,
} from 'relay-runtime';
import { setMark } from '@jira/platform__early-script-utils/src/index.tsx';
import { buildGraphqlFetch } from '@jira/platform__graphql-relay-fetch/src/services/multipart-fetch/index.tsx'; // TODO This will need to import from Platform
import { generateOptions } from '@jira/platform__graphql-relay-fetch/src/utils.tsx';
import {
	putEarlyScriptPromise,
	getEarlyScriptPromiseKey,
} from '@jira/platform__graphql-relay-vendorless-promise/src/index.tsx';
import { getAggEndpoint, getRequestBody } from '@atlassian/relay-endpoint';

export const earlyFetch = <TVariables extends Variables>(
	compiledQuery: ConcreteRequest | PreloadableConcreteRequest<OperationType>,
	variables: TVariables,
): void => {
	setMark('jira.fe-spa.early-preload:start');

	const endpoint = getAggEndpoint(compiledQuery.params);
	const body = getRequestBody(compiledQuery.params, variables);

	const fetchOverNetwork = buildGraphqlFetch(endpoint, generateOptions({ body }, endpoint));
	putEarlyScriptPromise(
		getEarlyScriptPromiseKey(compiledQuery.params, variables),
		fetchOverNetwork().then((response) => {
			setMark('jira.fe-spa.early-preload:end');

			return response;
		}),
	);
};
